import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';

export default function CallbackModal({ onClose, onSubmit }) {
  const [form, setForm] = useState({ name: '', phone: '', time: '' });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await onSubmit(form);
      setDone(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-md p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 dark:text-gray-300 hover:text-gray-600"
        >
          <FiX size={20} />
        </button>

        {done ? (
          <>
            <h3 className="text-2xl font-semibold mb-2 text-gray-800 dark:text-gray-100">
              Thank you!
            </h3>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              We’ll reach out at <span className="font-medium">{form.time}</span>.
            </p>
            <button
              onClick={onClose}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg transition"
            >
              Close
            </button>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <h3 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">
              Request a Callback
            </h3>
            <input
              name="name"
              placeholder="Name"
              value={form.name}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 dark:border-gray-600 p-3 rounded-lg focus:ring focus:ring-blue-200 dark:focus:ring-blue-500 transition"
            />
            <input
              name="phone"
              type="tel"
              placeholder="Phone"
              value={form.phone}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 dark:border-gray-600 p-3 rounded-lg focus:ring focus:ring-blue-200 dark:focus:ring-blue-500 transition"
            />
            <input
              name="time"
              type="datetime-local"
              value={form.time}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 dark:border-gray-600 p-3 rounded-lg focus:ring focus:ring-blue-200 dark:focus:ring-blue-500 transition"
            />
            <button
              type="submit"
              disabled={submitting}
              className="w-full flex justify-center items-center bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg transition disabled:opacity-50"
            >
              {submitting ? 'Sending…' : 'Submit Request'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
